import axios from "axios";
import API from "../../../config/networkInterceptor";

export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = "api/forgot-password";
export const LOGIN_URL = "api/auth/login";
export const ME_URL = "api/me";

export async function checkUserGroup() {
  return API.get("v1/users/user/admingroup");
}


export function login(email, password) {
  return API.post("login",
    {
      email: email,
      password: password,
      front: true
    });

}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  // return axios.post(REQUEST_PASSWORD_URL, { email });
  return API.post("changepassword",
  {
    email:email
  })
}

export function newPassword(email,password,q1,ans1,q2,ans2) {
  // return axios.post(REQUEST_PASSWORD_URL, { email });
  return API.post("setpassword",
  {
    email:email,
    password:password,
    securityQA:[
      {
        answer:ans1,
        questionId:q1
      },
      {
        answer:ans2,
        questionId:q2
      }
    ]
  })
  
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}

export function verifyCode(value) {
  return API.post(`verifycode`,
    // return API.post(`users/verifycode?langKey=${value.langKey}`,
    {
      email: value.email,
      otp: value.code 
    }
  )
}

